<div class="content">
    <router-outlet></router-outlet>
</div>
<jobs-view></jobs-view> 